export const PORTAL_STRING_OVERRIDES_KEY = '__PORTAL_STRING_OVERRIDES';

export function getPortalStringOverrides () {
  if (typeof sessionStorage === 'undefined') {
    return {};
  }
  try {
    const raw = sessionStorage.getItem(PORTAL_STRING_OVERRIDES_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed;
    }
  } catch (e) {
    // ignore invalid json
  }
  return {};
}

export function mergePortalLabels (labels = {}) {
  return {
    ...labels,
    ...getPortalStringOverrides()
  };
}

const persistAndReload = (overrides) => {
  sessionStorage.setItem(PORTAL_STRING_OVERRIDES_KEY, JSON.stringify(overrides));
  if (typeof window.location?.reload === 'function') {
    window.location.reload();
  }
};

export function registerPortalStringOverrideDevTools () {
  if (typeof window === 'undefined') {
    return;
  }
  window.getStringOverrides = () => ({
    ...getPortalStringOverrides()
  });
  window.setStringOverrides = (overrides) => {
    if (!overrides || typeof overrides !== 'object' || Array.isArray(overrides)) {
      return getPortalStringOverrides();
    }
    persistAndReload({
      ...getPortalStringOverrides(),
      ...overrides
    });
  };
  window.clearStringOverrides = () => {
    sessionStorage.removeItem(PORTAL_STRING_OVERRIDES_KEY);
    if (typeof window.location?.reload === 'function') {
      window.location.reload();
    }
  };
}
